import { Injectable } from "@angular/core";
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpErrorResponse,
} from "@angular/common/http";
import { Storage } from "@ionic/storage";
import { ModalController, ToastController } from "@ionic/angular";
import { TranslateService } from "@ngx-translate/core";
import { Observable, from, throwError } from "rxjs";
import { catchError, mergeMap } from "rxjs/operators";
import { UserProvider } from "../user/user";
import { Router } from "@angular/router";

@Injectable()
export class InterceptorProvider implements HttpInterceptor {
  constructor(
    private storage: Storage,
    public userProvider: UserProvider,
    private toastCtrl: ToastController,
    private translate: TranslateService,
    public router: Router,
    public modalCtrl: ModalController
  ) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return from(this.storage.get("token")).pipe(
      mergeMap((token) => {
        let clonedReq;
        clonedReq =
          request.url.indexOf("maps.googleapis.com") === -1
            ? this.addToken(request, token)
            : request;

        return next.handle(clonedReq).pipe(
          catchError((error: any) => {
            // if (error.status === 0) {
            //   this.modalCtrl.dismiss(null, undefined).catch(() => {});
            //   let islogin = !token ? 1 : 0;
            //   this.router.navigate(["/acesso", islogin]);
            // }

            if (error instanceof HttpErrorResponse) {
              if (token) {
                this.toastCtrl
                  .create({
                    message: this.translate.instant(
                      "Conexão perdida, tente mais tarde."
                    ),
                    duration: 3000,
                  })
                  .then((toast) => toast.present());

                if (request.url.indexOf("mensagem/nao-lidas") !== -1) {
                  this.userProvider.logout().then(() => {
                    console.log("ok");
                  });
                }
              }
            }

            return throwError(error);
          })
        );
      })
    );
  }

  private addToken(request: HttpRequest<any>, token: any): HttpRequest<any> {
    if (token) {
      return request.clone({
        setHeaders: {
          Accept: `application/json`,
          'Content-Type': `application/json`,
          Authorization: `Bearer ${token}`,
        },
      });
    }

    return request;
  }
}
